import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Socios.scss";
import prudentialLogo from "../images/prudential.jpg"; // coloca aquí el logo de Prudential

const Socios = () => {
  return (
    <section className="sociosContainer" id="socios">
      <Fade>
        <div className="sociosContent">
          <img
            src={prudentialLogo}
            alt="Prudential Seguros México"
            className="logoPrudential"
          />
          <div className="textSocios">
            <h5 className="titleSocios">Socios Comerciales de Prudential Seguros México</h5>
            <p className="paragraphSocios">
              En <strong>Asesorarte en Seguros</strong> trabajamos de la mano con
              <b> Prudential Seguros México</b>, una de las compañías más sólidas y reconocidas a nivel mundial,
              respaldando nuestras soluciones financieras con experiencia, confianza y solidez internacional.
            </p>
            <a
              href="https://www.prudentialseguros.com.mx/PrudentialMexico/"
              target="_blank"
              rel="noopener noreferrer"
              className="linkPrudential"
            >
              ¿Quién es Prudential? Conócenos →
            </a>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default Socios;
